export enum SubNavigationTypes {
	MultiColumn = 'multi-column',
	Promo = 'promo',
	SingleColumn = 'single-column',
}
